import styled from 'styled-components';
import { Common, color } from '@stockbit/ui';

const InputContainer = styled(Common.InputContainer)`
  label {
    font-family: 'ProximaNovaLt';
  }
`;

const Input = styled(Common.Input).attrs({ p: '0', type: 'password' })`
  font-size: 20px;
  width: 100% !important;
  font-family: 'ProximaNovaLt' !important;
  font-weight: 300;

  input {
    &::placeholder {
      font-family: 'ProximaNovaLt';
      font-weight: 300;
    }
  }
`;

const ErrorText = styled(Common.Text).attrs({
  color: color.venetianRed,
})`
  font-family: 'ProximaNovaLt';
  font-weight: 300;
`;

export { Input, InputContainer, ErrorText };
